var map = {
	"./finance/dashboard/DebtorsDashboard": 258,
	"./finance/dashboard/DebtorsDashboard.vue": 258,
	"./stock/dashboard/StockDashboard": 259,
	"./stock/dashboard/StockDashboard.vue": 259
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1294;


//////////////////
// WEBPACK FOOTER
// ./src/modules Dashboard
// module id = 1294
// module chunks = 0